var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { theme, ButtonGeneral, ButtonPrimary, Input, LabelSmall, ContentBox, H4 } from '@by-miles/bymiles-styles';
import { DataLayer } from '@by-miles/data-layer';
import { DynamicTitle } from '../DynamicTitle';
import { AgeStyle } from './AgeStyle';
import { eventSection } from '../../utils/event';
var AgeInput = function (props) { return (_jsx(Input, { name: "age", placeHolder: "Age", keepLabel: false, type: "number", className: "age-input", errorNoMessage: props.ageError, onChange: props.onChange, valid: props.valid, value: props.value })); };
export var Age = function (ageProps) {
    var updateDataState = ageProps.updateDataState, updateState = ageProps.updateState, step = ageProps.step, ages = ageProps.ages, multipleAges = ageProps.multipleAges, updateStepAndAgesQQPage = ageProps.updateStepAndAgesQQPage, isQQPage = ageProps.isQQPage;
    var _a = useState(false), ageError = _a[0], setAgeError = _a[1];
    var _b = useState({
        age1: false,
        age2: false,
        age3: false,
        age4: false,
    }), agesValid = _b[0], setAgesValid = _b[1];
    useEffect(function () {
        DataLayer.customEvent({
            eventName: 'age',
            eventType: 'virtual page view',
            section: eventSection(isQQPage),
        });
    }, []);
    var handleAgeConfirm = function () {
        var ages = document.querySelectorAll('input');
        var minimumAge = ages[0].value;
        var ageArray = [];
        if (!minimumAge) {
            setAgeError(true);
            return false;
        }
        else {
            setAgeError(false);
            ages.forEach(function (age) {
                if (age.value) {
                    ageArray.push(parseInt(age.value));
                }
            });
            if (updateStepAndAgesQQPage) {
                updateStepAndAgesQQPage({ ages: ageArray, step: step + 1 });
            }
            else {
                updateDataState({ stateName: 'ages', value: ageArray });
                updateState({ stateName: 'step', value: step + 1 });
            }
            DataLayer.customEvent({
                eventName: 'submit age',
                eventType: 'button click',
                section: eventSection(isQQPage),
            });
        }
    };
    var handleAgesValid = function (ageNumber, value) {
        var _a;
        if (ageNumber === 'age1' && ageError) {
            setAgeError(false);
        }
        setAgesValid(__assign(__assign({}, agesValid), (_a = {}, _a[ageNumber] = value > 16 && value < 102, _a)));
    };
    return (_jsxs(AgeStyle, __assign({ isQQPage: isQQPage, multipleAges: multipleAges }, { children: [_jsx("div", __assign({ className: "title-wrapper" }, { children: _jsx(DynamicTitle, { className: "enter-details-title", isQQPage: isQQPage, title: _jsx("span", { children: "Tell us a little about yourself." }) }) })), _jsx(ContentBox, __assign({ isQQPage: isQQPage, className: "content-box" }, { children: _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title age" }, { children: _jsx(H4, { children: multipleAges ? 'How old are the drivers?' : 'How old are you?' }) })), _jsxs("div", __assign({ className: "age-input-wrapper ".concat(!multipleAges ? 'solo' : '') }, { children: [_jsxs("div", __assign({ className: "age-input-item" }, { children: [multipleAges && _jsx(LabelSmall, { children: "You" }), _jsx(AgeInput, { errorNoMessage: ageError, onChange: function (event) { return handleAgesValid('age1', event); }, valid: agesValid.age1, value: ages[0] })] })), multipleAges &&
                                    Array(3)
                                        .fill(null)
                                        .map(function (_, index) {
                                        var number = index + 2;
                                        return (_jsxs("div", __assign({ className: "age-input-item" }, { children: [_jsxs(LabelSmall, { children: ["Driver ", number] }), _jsx(AgeInput, { errorNoMessage: ageError, onChange: function (event) { return handleAgesValid('age' + number, event); }, valid: agesValid['age' + number], value: ages[index + 1] })] }), index + 2));
                                    })] })), !multipleAges && (_jsx(ButtonGeneral, { style: { marginBottom: "".concat(theme.grid.spacing.base, "px") }, label: "Add additional drivers", onClick: function () {
                                updateState({ stateName: 'multipleAges', value: true });
                                DataLayer.customEvent({
                                    eventName: 'additional drivers age',
                                    eventType: 'button click',
                                    section: eventSection(isQQPage),
                                });
                            } })), _jsx("div", __assign({ className: "button-wrapper" }, { children: _jsx(ButtonPrimary, { iconRight: "IconCaretRight", label: "continue", onClick: function () { return handleAgeConfirm(); } }) }))] }) }))] })));
};
